import axios from 'axios'

export async function getPublicDashboard(token) {
  const response = await axios.get(`/api/v1/public/dashboards/${encodeURIComponent(token)}/`)
  return response.data
}
